import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_9: R2BReferralBrandEntity = {
  token: "r2b_referral_9",
  type: "r2bReferralBrand",
  name: "Hearth & Home Co.",
  email: "sarah.wilson@example.com",
  website: "hearthhome.co",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
